import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { MyFilesService } from 'src/app/services/myfiles.service';
import { catchError, map, of } from 'rxjs';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';


interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}


@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})

export class UploadComponent {
// 'space', '~', ':', "'", '+', '[', '\\', '@', '^', '{', '%', '(', '-', '"', '*', '|', ',', '&', '<', '`', '}', '.', '_', '=', ']', '!', '>', ';', '?', '#', '$', ')', '/'"
  
  @Input()
  accepted_formats: string = ".wav, .mp3"

  @Input()
  display_event_data: boolean = true

  @Input() db_store: boolean = true;
  @Output() fileEvent: EventEmitter<string>;
  email!: string;

  filename: string = "";

  event_details: FormGroup<any>;
  time: any;
  name: any;
  location: any;
  filtered_locations: any;
  maxAllowedDate: any;

  locations = [
    { name: 'Boardroom 30 Rockefeller', code: 'B-30-Rockfeller' },
    { name: 'Boardroom DU', code: 'B-DU' },
  ]


  constructor(public commonservice: CommonService, private fb: FormBuilder, private fileService: MyFilesService) {

    this.event_details = this.fb.group({
      name: ['', Validators.required],
      time: [null, Validators.required],
      location: ['', Validators.required]
    });
    this.maxAllowedDate = new Date();

    this.fileEvent = new EventEmitter();
    this.filtered_locations = this.locations;

  }

  ngOnInit(){
    this.commonservice.loggedInUser.subscribe((user:any) => {
      this.email = user.userPrincipalName;
    })
  }

  get_date_formatted(isoDate: Date) {
    const formatted_date = new Intl.DateTimeFormat('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }).format(new Date(isoDate));

    return formatted_date;
  }

  uploadFile($event: any) {

    let file = $event.target.files[0];
    if (file) {
      if (!this.accepted_formats.split(",").some(suffix => file.name.toLowerCase().endsWith(suffix.toLowerCase().trim()))) {
        alert(`select only from accepted formats ${this.accepted_formats}`)
        return
      } else {
        const formData = new FormData();
        formData.append('file', file);
        this.filename = file.name;

        formData.append('user_email', this.email);
        formData.append('db_store', this.db_store.toString());

        let event_details = {
          "name": this.event_details.controls['name'].value,
          "location": this.event_details.controls['location'].value.name,
          "time": this.get_date_formatted(this.event_details.controls['time'].value)
        }

        formData.append('event_details', JSON.stringify(event_details));
        this.fileService.uploadFile(formData).pipe(
          map((event: any) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                file.progress = Math.round(event.loaded * 100 / event.total);
                break;
              case HttpEventType.Response:
                return event;
            }
          }),
          catchError((error: HttpErrorResponse) => {
            file.inProgress = false;
            alert(`${file.data.name} upload failed.`);
            return of(`${file.data.name} upload failed.`);
          })
        ).subscribe((event: any) => {
          if (typeof (event) === 'object') {
            if (this.db_store) {
              this.commonservice.selected_file = event.body.file_url;
              this.fileService.setIDSubject(event.body.uuid);
              this.fileService.getContentbyID(event.body.uuid).subscribe((data: any) => { console.log(data) })
            } else {
              this.fileEvent.emit(event.body.file_url);
            }
          }
        });
      }
    }
  }

  get_name_from_url(url: string) {
    return url.substring(url.lastIndexOf('/') + 1);
  }

  check_form_status(){
    if(!this.display_event_data){
      return false;
    }else{
      return this.event_details.untouched || this.event_details.invalid
    }
  }

}




